<template>
  <vDialog :show.sync="visible" class="password_renewal_reminder_dialog">
    <template v-slot:header>
      <span class="close"><i class="el-icon el-icon-close" @click="handleClose"></i></span>
      <div class="font-semibold text-xl text-blackG2">{{ $t('security.passwordRenewalReminder.header') }}</div>
    </template>
    <template v-slot:body>
      <div class="text-sm mt-8">
        {{ $t('security.passwordRenewalReminder.desc', { days: limitDayNumber }) }}
      </div>
    </template>
    <template v-slot:btn>
      <div class="footer_btn">
        <SecondaryButton padding="px-10" height="h-12" width="min-w-42" :onClick="handleClose" class="dialog-btn"
          >{{ $t('security.cancel') }}
        </SecondaryButton>
        <PrimaryButton
          padding="px-10"
          height="h-12"
          width="min-w-42"
          :onClick="confirmSubmit"
          class="dialog-btn"
          bgColor="!bg-blueG1"
          >{{ $t('security.confirm') }}
        </PrimaryButton>
      </div>
    </template>
  </vDialog>
</template>

<script>
import vDialog from '@/components/vDialog.vue';
import PrimaryButton from '@/components/buttons/primaryButton/PrimaryButton.vue';
import SecondaryButton from '@/components/buttons/secondaryButton/SecondaryButton.vue';
import { apiGetCurrentSecurity } from '@/resource';

export default {
  name: 'PasswordRenewalReminderDialog',
  components: { vDialog, PrimaryButton, SecondaryButton },
  props: {
    reminderDialogVisible: Boolean,
    token: String
  },
  data() {
    return {
      visible: false,
      limitDayNumber: undefined
    };
  },
  watch: {
    reminderDialogVisible(bool) {
      if (bool) {
        this.getFreezePeriod().then(resp => {
          if (resp && this.limitDayNumber) {
            this.visible = bool;
          } else {
            this.confirmSubmit();
          }
        });
      }
    },
    visible(bool) {
      this.$emit('update:reminderDialogVisible', bool);
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    confirmSubmit() {
      this.visible = false;
      this.$emit('confirmSubmit');
    },
    async getFreezePeriod() {
      try {
        let result = false;
        await apiGetCurrentSecurity('updatePassword').then(resp => {
          if (resp.data.code === 0) {
            if (resp.data.data.ruleContent) {
              this.limitDayNumber = resp.data.data.ruleContent.withdraw.limitTime;
              result = true;
            }
          } else {
            console.error('Get limit day number fails');
          }
        });
        return result;
      } catch (error) {
        console.error('error', error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.password_renewal_reminder_dialog {
  .footer_btn {
    display: flex;
    justify-content: center;

    @media (max-width: 767px) {
      display: block;
      text-align: center;
    }
  }

  .close {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .dialog-btn {
    @include rtl-sass-prop(margin-left, margin-right, 10px);
  }

  /deep/ {
    .el-dialog__header {
      padding: 5px 20px;
    }
  }
}
</style>
